module.exports = __webpack_public_path__ + "static/img/banner-gol.2bdb8416.png";